import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import Select from "react-select";
import DistanciaVista from "./DistanciaVista";

function DistanciaOffer(props) {
  const [dataarea, setDataArea] = useState("");
  const [facultad, setFacultad] = useState("");
  const [modalidad, setModalidad] = useState("");
  const [width, setWidth] = useState(window.innerWidth);

  const updateWindowDimensions = () => {
    const newW = window.innerWidth;
    setWidth(newW);
  };
  useEffect(() => {
    window.addEventListener("resize", updateWindowDimensions);
  }, []);

  function handleChange(e) {
    const { value, checked } = e.target;
    if (checked) {
      setFacultad(value);
    } else {
      setFacultad("0");
    }
  }
  function handleModalidad(e) {
    const { value, checked } = e.target;
    if (checked) {
      setModalidad(value);
    } else {
      setModalidad("0");
    }
  }
  function handleChangeMobile(value) {
    setFacultad(value);
  }

  function handleModalidadMobile(value) {
    setModalidad(value);
  }

  const optionsfacultad = [
    {
      value: "Ciencias Económicas y Empresariales",
      label: "Ciencias Económicas y Empresariales",
    },
    {
      value: "Ciencias Exactas y Naturales",
      label: "Ciencias Exactas y Naturales",
    },
    {
      value: "Ciencias Sociales, Educación y Humanidades",
      label: "Ciencias Sociales, Educación y Humanidades",
    },
    {
      value: "Ciencias Jurídicas y Políticas",
      label: "Ciencias Jurídicas y Políticas",
    },
    {
      value: "Ingenierías y Arquitectura",
      label: "Ingenierías y Arquitectura",
    },
    { value: "0", label: "-" },
  ];

  const optionsmodalidad = [
    {
      value: "En línea",
      label: "En línea",
    },
    {
      value: "a Distancia",
      label: "a Distancia",
    },

    { value: "0", label: "-" },
  ];
  return (
    <div className="layout9">
      <div className="wrapper-titleoffer ">
        <motion.div
          initial={{ y: 200, opacity: 0 }}
          whileInView={{
            y: 0,
            opacity: 1,
            transition: {
              type: "spring",
              stiffness: 200,
            },
          }}
        >
          {props.title}
        </motion.div>
      </div>
      <h2>{props.subtitle}</h2>
      <div className="offerbymodelo">
        {width > 900 && (
          <div>
            <div className="layout9 ">
              <p>
                <b>Modalidad</b>
              </p>

              <div className="item">
                <input
                  type="radio"
                  name="modalidad"
                  value="0"
                  id="todasmodalidad"
                  onChange={handleModalidad}
                />
                <label className="form-check-label" htmlFor="todasmodalidad">
                  Todas
                </label>
              </div>

              <div className="item">
                <input
                  type="radio"
                  name="modalidad"
                  value="En línea"
                  id="enlinea"
                  onChange={handleModalidad}
                />
                <label className="form-check-label" htmlFor="enlinea">
                  En línea
                </label>
              </div>
              <div className="item">
                <input
                  type="radio"
                  name="modalidad"
                  value="a Distancia"
                  id="distancia"
                  onChange={handleModalidad}
                />
                <label className="form-check-label" htmlFor="distancia">
                 a Distancia
                </label>
              </div>

              <p>
                <b>Facultad</b>
              </p>

              <div className="item">
                <input
                  type="radio"
                  name="languages"
                  value="0"
                  id="todas"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="todas">
                  Todas
                </label>
              </div>

              <div className="item">
                <input
                  type="radio"
                  name="languages"
                  value="Facultad de Ciencias Económicas y Empresariales"
                  id="empresas"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="empresas">
                  Ciencias Económicas y Empresariales
                </label>
              </div>
              <div className="item">
                <input
                  type="radio"
                  name="languages"
                  value="Facultad de Ciencias Exactas y Naturales"
                  id="ciencias"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="ciencias">
                  Ciencias Exactas y Naturales
                </label>
              </div>
              <div className="item">
                <input
                  type="radio"
                  name="languages"
                  value="Facultad de Ciencias Sociales, Educación y Humanidades"
                  id="sociales"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="sociales">
                  Ciencias Sociales, Educación y Humanidades
                </label>
              </div>
              <div className="item">
                <input
                  type="radio"
                  name="languages"
                  value="Facultad de Ciencias Jurídicas y Políticas"
                  id="juridicas"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="juridicas">
                  Ciencias Jurídicas y Políticas
                </label>
              </div>
              <div className="item">
                <input
                  type="radio"
                  name="languages"
                  value="Facultad de Ingenierías y Arquitectura"
                  id="ing"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="ing">
                  Ingenierías y Arquitectura
                </label>
              </div>

              <p>
                <b>Área de interés</b>
              </p>

              <div className="wrapper-inputoffer">
                <input
                  className="input-academicoffer"
                  name="area"
                  value={dataarea}
                  onChange={(e) => setDataArea(e.target.value)}
                  placeholder="Ejemplo: empresas"
                ></input>
                <span className="material-icons">search</span>
              </div>
            </div>
          </div>
        )}

        {width < 900 && (
          <div>
            <p>
              <b>Facultad</b>
            </p>
            <Select
              options={optionsfacultad}
              defaultValue={facultad}
              onChange={handleChangeMobile}
            ></Select>
            <p>
              <b>Modalidad</b>
            </p>
            <Select
              options={optionsmodalidad}
              defaultValue={modalidad}
              onChange={handleModalidadMobile}
            ></Select>

            <p>
              <b>Área de interés</b>
            </p>
            <div className="wrapper-inputoffer">
              <input
                className="input-academicoffer"
                name="area"
                value={dataarea}
                onChange={(e) => setDataArea(e.target.value)}
                placeholder="Ejemplo: empresas"
              ></input>
              <span className="material-icons">search</span>
            </div>
          </div>
        )}

        <div>
          {width > 900 && (
            <DistanciaVista
              title="Elige tu carrera"
              keyword={dataarea.trimEnd().toLowerCase()}
              facultad={facultad}
              modalidad={modalidad}
            ></DistanciaVista>
          )}
          {width < 900 && (
            <DistanciaVista
              title="Elige tu carrera"
              keyword={dataarea.trimEnd().toLowerCase()}
              facultad={facultad.value}
              modalidad={modalidad.value}
            ></DistanciaVista>
          )}
        </div>
      </div>
    </div>
  );
}

export default DistanciaOffer;
